import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UtilityService } from '../../services';

@Component({
  selector: 'app-select-field',
  templateUrl: './global.select.component.html'
})
export class GlobalSelectComponent {

  @Output() modelChange = new EventEmitter<any>();
  @Input() label: string;
  @Input() tooltip: string;
  @Input() options: Array<any>;
  @Input() valueKey: string;
  @Input() optionKey: string;
  @Input() multiple = false;
  @Input() hint: string;
  @Input() control: FormControl;

  constructor(private util: UtilityService) { }

  isRequired() {
    return this.util.isRequired(this.control);
  }
  emitChange(event) {
    this.modelChange.emit(event);
  }
}
